export { StepperInglesLargo } from "./StepperInglesLargo";
